import SV from 'server-vars';
import { sessionStorage } from 'dibs-browser-storage';
import { getEverLoggedIn, getBuyerId } from 'dibs-cookie-jar';
import tracking from 'dibs-tracking';
import { PAGE_TYPE, BROWSE_TYPES } from '../../utils/pageConstants';
import { gaLabels } from '../../authModal/postAuth/constants';
import { VisitCountModel } from 'dibs-visit-tracking/exports/visitCountModel';
import authModalLoader from '../../utils/AuthModalLoader';
import * as postAuthLoader from './helpers/postAuthLoader';
import isPageType from '../../utils/isPageType';
import { isPlaReferrer } from './helpers/referrerHelper';

const isAllowedPageType = () => {
    const isPdpPrintPage = SV.get('settings.isPrintPDP');
    const allowedPageTypes = [PAGE_TYPE.HOME, PAGE_TYPE.CREATOR, PAGE_TYPE.DEALER, PAGE_TYPE.PDP];

    const isAllowedPage = isPageType([...allowedPageTypes, ...BROWSE_TYPES]);

    return isAllowedPage && !isPdpPrintPage;
};

/**
 * should visitor be prompted to login?
 * @returns {boolean}
 */
const isBlocked = function isBlocked() {
    const searchParams = new URLSearchParams(location.search);
    const loggedIn = getBuyerId(document.cookie);
    if (loggedIn || searchParams.has('modal') || !isAllowedPageType() || isPlaReferrer()) {
        return true;
    }
    return false;
};

const shouldPromptLoginRegistration = visitCountModel => {
    return visitCountModel.get('session') === visitCountModel.get('regPromptLimit');
};

const canAutoPromptUser = () => {
    const visitCountModel = new VisitCountModel();
    const isModalBlocked = isBlocked();
    const shouldOpenModal = shouldPromptLoginRegistration(visitCountModel);
    if (shouldOpenModal && !isModalBlocked) {
        return true;
    } else if (shouldOpenModal && isModalBlocked) {
        visitCountModel.increment('regPromptLimit');
        visitCountModel.save();
        return false;
    } else {
        return false;
    }
};

/**
 * prompts visitor to register if it's due
 * @return {boolean} true if login prompted
 */
const openLoginModal = () => dispatch => {
    const flow = authModalLoader.constants.PAGEVIEW_LIMIT_FLOW;
    const ga = {
        label: gaLabels.PAGEVIEW_LIMIT_REACHED,
    };

    sessionStorage.setItem('authModalShown', true);
    tracking.trackEvent({
        category: 'promo interaction',
        action: 'auto modal displayed',
        label: 'auto pageview',
    });

    if (!getEverLoggedIn(document.cookie)) {
        postAuthLoader.autoPromptRegistration({ flow, launchOrigin: ga.label });
    } else {
        authModalLoader.show({
            action: authModalLoader.constants.LOGIN,
            flow,
            ga,
            fireEntryGa: true,
        });
    }
    dispatch({ type: 'noop' });
};

/**
 * Checks condition for auto prompt user.
 * Opens modal if condition is satisfied.
 * Condition:
 * page view >= 2,
 * home / browse / creator / pdp (not print) page type,
 * User is not logged in and AuthModal is not opened.
 *
 * @return {Promise}
 */
const loginPromptRule = function loginPromptRule() {
    return Promise.resolve(canAutoPromptUser());
};

export default {
    name: 'loginPrompt',
    rule: loginPromptRule,
    action: openLoginModal,
    priority: 250,
};
